import { t } from './od_i18n.js?v=animate-1';

const storageKey=(surface,uid)=>`od_feature_animate_v1_${surface}_${uid||'local'}`;
export function acknowledgeAnimationAnnouncement(surface,uid){
  try{localStorage.setItem(storageKey(surface,uid),'1');}catch{}
}

// A separate release notice, so completing the original onboarding never hides it.
// It stays available until explicitly tried or dismissed, independently per page.
export function showAnimationAnnouncement({surface,uid,getPlays=()=>[],onTry,onCreate}){
  try{if(localStorage.getItem(storageKey(surface,uid)))return;}catch{}
  if(document.querySelector(`[data-animation-news="${surface}"]`))return;
  const anchor=document.querySelector(surface==='editor'?'.workspace':'.tableWrap95');
  if(!anchor)return;
  const banner=document.createElement('section');banner.className='odAnimationNews';banner.dataset.animationNews=surface;
  banner.setAttribute('aria-labelledby',`odAnimationNewsTitle-${surface}`);
  banner.innerHTML=`<span class="odAnimationNewsIcon" aria-hidden="true">▶</span><div class="odAnimationNewsContent"><span class="odAnimationNewsBadge">${t('animate_new')}</span><h2 id="odAnimationNewsTitle-${surface}">${t('animate_news_title')}</h2><p>${t('animate_news_'+surface)}</p><div class="odAnimationNewsPicker" hidden></div></div><button type="button" class="odAnimationNewsTry">${t('animate_news_try')} →</button><button type="button" class="odAnimationNewsClose" aria-label="${t('animate_news_close')}">×</button>`;
  const media=surface==='organizer'?['(max-width:980px)','(pointer:coarse)','(hover:none)'].map(query=>window.matchMedia(query)):[];
  function position(){
    const mobile=document.getElementById('odMobileMount');
    if(mobile && media.some(query=>query.matches))mobile.prepend(banner);
    else anchor.before(banner);
  }
  position();media.forEach(query=>query.addEventListener('change',position));
  function dismiss(){acknowledgeAnimationAnnouncement(surface,uid);banner.remove();media.forEach(query=>query.removeEventListener('change',position));}
  banner.querySelector('.odAnimationNewsClose').addEventListener('click',()=>{
    dismiss();document.querySelector(surface==='editor'?'#odAnimateBtn':'#btnNewPlay')?.focus();
  });
  banner.querySelector('.odAnimationNewsTry').addEventListener('click',()=>{
    if(surface==='editor'){dismiss();onTry?.();return;}
    const picker=banner.querySelector('.odAnimationNewsPicker');picker.replaceChildren();picker.hidden=false;
    const plays=getPlays().filter(play=>play?.id);
    if(!plays.length){
      const message=document.createElement('p');message.textContent=t('animate_news_empty');
      const create=document.createElement('button');create.type='button';create.textContent=t('animate_news_create');
      create.addEventListener('click',()=>{dismiss();onCreate?.();});picker.append(message,create);create.focus();return;
    }
    const label=document.createElement('label');label.textContent=t('animate_news_choose');
    const select=document.createElement('select');select.append(new Option(t('animate_news_select'),''));
    for(const play of plays){select.append(new Option(`${play.name||t('animate_news_untitled')}${play.teamName?' · '+play.teamName:''}`,play.id));}
    label.append(select);
    const open=document.createElement('button');open.type='button';open.textContent=t('animate_news_open');open.disabled=true;
    select.addEventListener('change',()=>{open.disabled=!select.value;});
    open.addEventListener('click',()=>{
      if(!getPlays().some(play=>play.id===select.value))return;
      dismiss();onTry?.(select.value);
    });
    picker.append(label,open);select.focus();
  });
}

// Called after the editor has finished loading the requested play.
export function openRequestedAnimation(uid){
  const url=new URL(window.location.href);
  if(url.searchParams.get('animate')!=='1')return false;
  const button=document.getElementById('odAnimateBtn');if(!button)return false;
  url.searchParams.delete('animate');history.replaceState(history.state,'',url);
  acknowledgeAnimationAnnouncement('editor',uid);
  button.focus();button.click();return true;
}
